import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'

import Banner from '@/components/Banner'
import Contact from '@/components/Contact'

import {getProductList} from '@/api/server/product'
import {getCategoryList} from '@/api/server/category'
import {getClassification} from '@/api/server/classification'

import Product from '@/components/Product'
import Tabbar from '@/components/Tabbar'
import Osearch from '@/components/osearch'
import Category from '@/components/Category'
import Brand from '@/components/Brand'

export default {
  name: 'ListPage',
  mixins: [commonMixin],
  data () {
    return {
      list: [],
      pagesize: 8,
      page: 1,
      total: 0,
      retSize: 6,
      loading: false,
      hots: [],
      categoryList: [],
      categoryId: null,
      activeName: 'time',
      price: 0,
      order: null,
      key: null,
      classification: [],
      cid: 1,
      banner: null,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    Banner,
    Contact,
    Product,
    Tabbar,
    Osearch,
    Category,
    Brand
  },
  computed: {
    noMore () {
      let more = false
      if ( this.retSize !== this.pagesize ) {
        more = true
      }
      return more
    },
    disabled () {
      return this.loading || this.noMore
    },
    priceUpStatus () {
      if (this.activeName === 'price' && this.order === 'desc') {
        return true
      } else {
        return false
      }
    },
    priceDownStatus () {
      if (this.activeName === 'price' && this.order === 'asc') {
        return true
      } else {
        return false
      }
    },
    categoryName () {
      let classification = this.classification
      let cid = this.cid
      if (cid && classification) {
        let category = this.classification.find( item => {
          return (item.id).toString() === cid
        })
        if (category) {
          return category.title
        }
      }
    }    
  },
  methods: {
    // 修改品牌ID
    onChangeBranch (item) {
      if (item && item.id) {
        this.categoryId = item.id
      } else {
        this.categoryId = null
      }
      this.page = 1
      this.load(true)
    },
    // 修改分类 ID
    onChangeCid (item) {
      if (item && item.id) {
        this.cid = item.id
      }
      this.categoryId = null
      this.page = 1
      this.load(true)
    },
    onSearchList (key) {
      this.key = key
      this.page = 1
      this.cid = 0
      this.categoryId = 0
      this.load(true)
    },
    oformatDate (str) {
      return formatDate(str)
    },
    onSelect (item) {
      this.categoryId = item.id
      this.page = 1
      this.page = 1
      this.load(true)
    },
    onAll () {
      this.categoryId = 0
      this.page = 1
      this.load(true)
    },
    onActive (value) {
      this.activeName = value
      if (value === 'price') {
        if (this.order && this.order === 'desc') {
          this.order = 'asc'
        } else {
          this.order = 'desc'
        }
      }
      this.page = 1
      this.load(true)
    },
    onDetail (id) {
        this.$router.push({name: 'detail', query:{ id: id}});
    },
    // _getCategory () {
    //   let query = {
    //     cid: this.cid
    //   }
    //   getCategoryList(query).then( (res) => {
    //     if (res.code === 200) {
    //       this.categoryList = res.data
    //     }
    //   })
    // },
    load (override = false) {
      let query = {
          page: this.page,
          pagesize: this.pagesize,
          category: this.categoryId,
          order_field: this.activeName,
          order: this.order,
          keyword: this.key,
          cid: this.cid
      }
      this.loading =  true
      getProductList(query).then((data) => {
        this.loading = false
        this.page = this.page + 1
        if (data.code === 200 && data.data && data.data.data) {
            let rdata = data.data
            this.retSize = rdata.data.length

            if (!override && this.list && this.list.length > 0) {
              this.list = this.list.concat(rdata.data)
            } else {
              this.list = rdata.data
            }
            this.total = rdata.total
        } else {
            this.warning(data.message)
        }
      }).catch((e) => {
        this.loading = false
        console.log('err', e)
      })
    },
    // _getClassification () {
    //   getClassification().then( (res) => {
    //     if (res.code === 200 && res.data) {
    //       this.classification = res.data
    //     }
    //   })
    // },
    reset () {
      this.list = [],
      this.page = 1
      this.total = 0
      this.categoryList = []
      this.activeName = 'time'
      this.price = 0

      this.load(true)
      // this._getCategory()
      // this._getClassification()
    
    },
    handleRoute (route) {
      if (route.name === 'list') {
        this.categoryId = this.$route.query.id
        this.cid = this.$route.query.cid
        this.key = this.$route.query.key
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}